module.exports = __webpack_public_path__ + "static/media/badminton.79086bee.svg";